import { NgModule } from '@angular/core';

import { BFPinwheel5Component } from './bf-pinwheel-5.component';

@NgModule({
  declarations: [BFPinwheel5Component],
  exports: [BFPinwheel5Component],
})
export class BFPinwheel5ComponentModule {}
